import { combineReducers } from 'redux';

import connectivityReducer from './connectivity';
import coverDataReducer from './coverData';
import divisionsReducer from './divisions';
import facilitiesReducer from './facilities';
import organizationsReducer from './organizations';
import projectsQueryReducer from './projectsQuery';
import reportDetails from './reportDetails';
import rolesReducer from './roles';
import usersReducer from './users';
import tutorialsReducer from './tutorials';

export default combineReducers({
	connectivity: connectivityReducer,
	coverData: coverDataReducer,
	divisions: divisionsReducer,
	roles: rolesReducer,
	users: usersReducer,
	organizations: organizationsReducer,
	projectsQuery: projectsQueryReducer,
	reportDetails: reportDetails,
	facilities: facilitiesReducer,
	tutorials: tutorialsReducer,
});
